import axios from 'axios';

const ParticipationService = {
  async getParticipations({ loanId, lenderId }) {
    const response = await axios.get('/participation', {
      params: {
        loan_id: loanId,
        lender_id: lenderId,
      },
    });

    return response.data;
  },

  async getParticipation(participationId) {
    const response = await axios.get(`/participation/${participationId}`);

    return response.data;
  },

  async createParticipation({ formValues, loanId }) {
    const response = await axios.post('/participation', {
      ...formValues,
      loan_id: loanId,
    });

    return response.data;
  },

  async updateParticipation({ formValues, participationId }) {
    const response = await axios.put(`/participation/${participationId}`, {
      ...formValues,
    });

    return response.data;
  },

  async deleteParticipation(participationId) {
    const response = await axios.delete(`/participation/${participationId}`);

    return response.data;
  },
};

export default ParticipationService;
